import { useFormik } from 'formik';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { object, string } from 'yup';
import theRapixLOgo from "../assets/Logo_main.svg";
import theRapixLOgoSmall from "../assets/Logo_small.svg";
import theRapixLOgoApp from '../assets/Logo_app.svg';
import FieldWrap from '../components/form/FieldWrap';
import Input from '../components/form/Input';
import Validation from '../components/form/Validation';
import Icon from '../components/icon/Icon';
import PageWrapper from '../components/layouts/PageWrapper/PageWrapper';
import Button from '../components/ui/Button';
import { authPages } from '../config/pages.config';
import { useAuth } from '../context/authContext';
import { forgotPassword } from '../services/apiService';
import LogoTemplate from '../templates/layouts/Logo/Logo.template';

export type TValues = {
	email: string;
};

const validationSchema = object({
	email: string()
		.email('Invalid email address')
		.required('Required'),
});

const ForgotPasswordPage = () => {
	const { loading, call } = forgotPassword();
	const { onLogout } = useAuth();

	const formik = useFormik({
		initialValues: {
			email: '',
		},
		validationSchema,
		onSubmit: (values: TValues, { setFieldError }) => {
			call(values.email).subscribe({
				next: (res: any) => {
					formik.resetForm();
					toast.success(res.msg);
				},
				error: (e: any) => {
					if (e?.status=== 409) {
						onLogout(e?.status);
					}
					toast.error(e?.data?.msg || e.message);
				}
			})
		}
	});

	return (
		<PageWrapper isBeforeLoginRoute={true} isProtectedRoute={false} className='bg-white ' name='Forgot Password'>
				<div className='flex h-full items-center justify-center'>
					<div className='w-full h-full flex-row flex'>
						<div className='w-1/2 mx-auto flex secondary-bg-opacity'>

							<div className='flex mx-auto my-5 basis-2/3' >

								<img src={theRapixLOgo} alt="THERapix" className="home-logo   " />

							</div>

						</div>
						<div className='w-1/2  text-black mx-auto flex justify-center items-center'>
							<div className='flex max-w-md flex-col gap-8 text-black'>
							<div className="flex gap-4 items-center">
								{/* <LogoTemplate className='h-12' />1 */}
								<div className='logo-small'>
									<img src={theRapixLOgoSmall} alt='THERapix' className='home-logo' />
								</div>
								<div className='flex max-w-sm flex-col gap-4'>
									<span className='text-4xl font-semibold'>Forgot Password</span>
									<span>Forgot Password with email address</span>
								</div>
							</div>
								<form className='flex flex-col gap-4' noValidate>
									<div>
										<Validation
											isValid={formik.isValid}
											isTouched={formik.touched.email}
											invalidFeedback={formik.errors.email}>
											<FieldWrap
												firstSuffix={<Icon icon='HeroEnvelope' className='mx-2' />}>
												<Input
													dimension='default'
													id='email'
													autoComplete='email'
													name='email'
													placeholder='Email'
													value={formik.values.email}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
												/>
											</FieldWrap>
										</Validation>
									</div>
									<div>
										<Button
											isLoading={loading}
											size='lg'
											variant='solid'
											className='w-full font-semibold primary-bg'
											onClick={() => formik.handleSubmit()}>
											Forgot Password
										</Button>
									</div>
								</form>
								<div>
									<span className='flex gap-2 text-sm justify-center'>
										<span className='text-zinc-400 dark:text-zinc-600 flex items-center'>
											Sign in instead?
										</span>
										<Link to={`${authPages.loginPage.to}`} className='hover:text-inherit font-semibold text-md'>
											Sign in
										</Link>
									</span>
								</div>
							</div>
						</div>

					</div>
				</div>
		</PageWrapper>
	);
};

export default ForgotPasswordPage;
